<template>
  <div class="entry-page">
    <h2>参加券の受け取り</h2>

    <div class="body">
      <template v-if="!orgName">
        <Button
          v-for="item in orgItems"
          :key="item.path"
          :to="getPath(item)"
          height="40px"
          font-size="14px"
          outlined
          class="body-button"
        >
          {{ item.text }}
        </Button>
      </template>
      <template v-else>
        <template v-if="!items">
          <form class="body-form" @submit.prevent="handleSubmit">
            <FormLabelTemplate :label="labelText" class="body-form-item">
              <TextField v-model="username"></TextField>
            </FormLabelTemplate>
            <FormLabelTemplate
              label="電話番号（※ハイフンなしでご入力ください）"
              class="body-form-item"
            >
              <TextField v-model="password"></TextField>
            </FormLabelTemplate>
            <Button height="36px" class="body-form-submit" type="submit"
              >受け取る</Button
            >
          </form>
        </template>
        <template v-else-if="items.length === 0">
          受け取れる参加券がありません
        </template>
        <template v-else>
          <div class="body-items">
            <div
              v-for="item in items"
              :key="item.cast_id"
              class="body-items-item"
            >
              <ExternalEventPanel
                :cast-name="item.external_cast_name"
                :quantity="item.quantity"
                :cast-image="item.external_cast_image"
                :open-time="item.open_time"
                :close-time="item.close_time"
                :part="item.part"
                :is-linked="item.is_linked"
              />
            </div>
          </div>
          <Button class="body-confirm" height="36px" to="/offline_events"
            >オフラインイベントの電子チケット一覧</Button
          >
          <Button height="36px" to="/events"
            >オンラインイベントの予約一覧</Button
          >
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '~/config'
import FormLabelTemplate from '~/components/molcules/FormLabelTemplate'
import TextField from '~/components/atoms/TextField'
import Button from '~/components/atoms/Button'
import ExternalEventPanel from '~/components/organisms/ExternalEventPanel'

export default {
  middleware: ['setAccessToken', 'requiredAuth', 'setCurrentUser'],
  components: {
    TextField,
    FormLabelTemplate,
    Button,
    ExternalEventPanel
  },
  data: () => ({
    username: '',
    password: '',
    items: undefined
  }),
  computed: {
    ...mapState(['currentUser']),
    labelText() {
      if (this.orgName === 'ske48') {
        return '＋ID（プラスID）'
      }
      return 'Official Shop盤を購入した際のAKB48グループID'
    },
    orgItems() {
      return [
        {
          path: 'akb48',
          text: 'AKB48'
        },
        {
          path: 'ske48',
          text: 'SKE48'
        }
      ]
    },
    orgName() {
      return this.$route.query.org
    }
  },
  mounted() {
    if (this.currentUser.image) {
      return
    }

    if (
      window.confirm(
        '参加券を受け取るためには本人確認書類のアップロードが必要です。今すぐアップロードしますか？'
      )
    ) {
      localStorage.setItem(config.redirectKey, this.$route.fullPath)
      this.$router.push('/upload')
    }
  },
  methods: {
    getPath(item) {
      return `/external/entry?org=${item.path}`
    },
    async handleSubmit() {
      try {
        this.$nuxt.$loading.start()
        const data = await this.$externalRepository.receipt({
          id: this.username,
          password: this.password
        })
        this.items = data
      } catch (error) {
        if (this.$error.isRequireCertificate({ error })) {
          const message = error.response.data.error
          window.alert(message)
          localStorage.setItem(config.redirectKey, this.$route.fullPath)
          this.$router.push('/upload')
        } else {
          this.$toast.error({ error })
        }
      } finally {
        this.$nuxt.$loading.finish()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.entry-page {
  padding: 16px 24px;
  max-width: 1040px;
  margin: 0 auto;
  color: #4a4a4a;

  > h2 {
    margin-bottom: 40px;
  }
}

.body {
  &-button {
    margin-bottom: 16px;
  }
  &-desc {
    margin-bottom: 32px;
  }

  &-form {
    &-item {
      margin-bottom: 16px;
    }

    &-submit {
      margin-top: 32px;
    }
  }

  &-items {
    &-item {
      margin-bottom: 16px;
    }
  }

  &-confirm {
    margin-bottom: 16px;
  }
}
</style>
